import "../src/jquery_global"
import * as Turbo from "@hotwired/turbo"
import "bootstrap";
import 'slick-carousel'
import 'slick-carousel/slick/slick.css';
import '@fortawesome/fontawesome-free/css/all.css'

// 他 MS と同様、Turbo Drive はグローバル無効。必要なリンク/フォームだけ data-turbo="true" で有効化する
Turbo.start();
Turbo.session.drive = false;

import "./autoselectPrefecture"
import "./common"
import "./fav"
import "./searchArea"
import "./top"
